import { IEntityId } from '../IEntityId';
import { Nullable } from '../Nullable';
import { SpellDuration } from './spell-duration';
import { SpellType } from './magic/spell-type';

export interface MagicSpell extends IEntityId<number> {
  castingValue: Nullable<string>;
  range: Nullable<string>;
  effect: Nullable<string>;
  typeLvl: SpellLvl;
  types: SpellType[];
  duration: SpellDuration;
}

export enum SpellLvl {
  ZERO = 0,
  ONE = 1,
  TWO = 2,
  THREE = 3,
  FOUR = 4,
  FIVE = 5,
  SIX = 6,
  A = 7,
  T = 8,
}
